<template>
    <div
        class="hero-donate"
        v-bind:class="{ 'hero-donate--is-recurring': isRecurring }"
    >
        <div class="hero-donate__title-container">
            <h2 class="hero-donate__title">{{ title }}</h2>
        </div>
        <div class="hero-donate__subtitle-container" v-if="isRecurring">
            <h3 class="hero-donate__subtitle">Kuukausittainen tukisumma</h3>
        </div>
        <div class="donate-block__prices">
            <span
                v-for="item in currentPrices"
                class="donate-block__price-container"
            >
                <button
                    class="donate-block__price"
                    v-bind:class="{
                        'donate-block__price--active':
                            currentPrice === item.price,
                    }"
                    v-on:click="setPrice(item.price)"
                >
                    {{ item.price }} €{{ isRecurring ? '/kk' : '' }}
                </button>
                <div
                    v-if="item.most_popular"
                    class="donate-block__most-popular"
                >
                    Suosituin summa
                </div>
            </span>
            <div class="donate-block__price-custom">
                <label
                    for="wwffi-custom-price"
                    class="donate-block__price-custom-text"
                    >Muu summa {{ isRecurring ? '/ kk' : '' }}:</label
                >
                <div class="donate-block__price-custom-input-wrapper">
                    <div
                        class="donate-block__price-custom-input-placeholder"
                        v-if="!customPriceFocus"
                    >
                        Alk. {{ minPrice }} €
                    </div>
                    <input
                        v-on:input="setCustomPrice"
                        v-on:focus="setCustomPriceFocus(true)"
                        v-on:blur="setCustomPriceFocus(false)"
                        ref="customPrice"
                        id="wwffi-custom-price"
                        v-imask="mask"
                        inputmode="numeric"
                    />
                </div>
            </div>
        </div>
        <div class="donate-block__submit">
            <form method="post" action="/lahjoitus/" v-on:submit="submit">
                <input name="quantity" value="1" type="text" hidden />
                <input
                    name="wwffi_donation_amount"
                    v-bind:value="currentPrice"
                    type="text"
                    hidden
                />
                <input
                    name="wwffi_campaign"
                    v-bind:value="campaign"
                    type="text"
                    hidden
                />
                <input
                    name="wwffi_preselect_gift"
                    v-bind:value="preselectGiftInt"
                    type="text"
                    hidden
                />
                <input
                    name="add-to-cart"
                    v-bind:value="productId"
                    type="text"
                    hidden
                />
                <div>
                    <button
                        class="donate-block__submit-button"
                        v-bind:disabled="!currentPrice"
                    >
                        {{ getButtonText() }}
                    </button>
                </div>
                <div class="donate-block__submit-error" v-if="error">
                    {{ error }}
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { IMaskDirective } from 'vue-imask';
import { sendAnalytics } from '../../analytics';
import customPrice from '../../blocks/donation/CustomPrice';

const businessDefaultPrices = [
    { price: '50', most_popular: false },
    { price: '250', most_popular: false },
    { price: '500', most_popular: false },
    { price: '1000', most_popular: false },
];

const defaultPrices = [
    { price: '15', most_popular: false },
    { price: '20', most_popular: true },
    { price: '30', most_popular: false },
];

export default {
    props: [
        'title',
        'prices',
        'productId',
        'campaign',
        'minPrice',
        'maxPrice',
        'analytics',
        'preselectGift',
        'isRecurring',
    ],
    data: function () {
        return {
            currentPrice: null,
            mask: {
                mask: 'num €',
                lazy: false,
                blocks: {
                    num: {
                        mask: Number,
                    },
                },
            },
            currentPrices: [],
            error: false,
            preselectGiftInt: this.preselectGift ? 1 : 0,
            customPriceFocus: false,
            useCustomPrice: false,
        };
    },
    directives: {
        imask: IMaskDirective,
    },
    mounted() {
        if (this.prices) {
            this.currentPrices = this.prices;
        } else if (!this.isRecurring) {
            this.currentPrices = businessDefaultPrices;
        } else {
            this.currentPrices = defaultPrices;
        }
    },
    methods: {
        submit(event) {
            this.error = false;

            if (this.currentPrice % 1 !== 0) {
                this.error = `Anna tasasumma`;
                event.preventDefault();
            }

            if (this.currentPrice < this.minPrice) {
                this.error = `Pienin lahjoitettava summa on ${this.minPrice} €${
                    this.isRecurring ? '/kk' : ''
                }`;
                event.preventDefault();
            } else if (this.currentPrice > this.maxPrice) {
                this.error =
                    'Tämän suuruisten lahjoitusten osalta pyydämme olemaan yhteydessä Tukijapalveluun, kiitos!';
                event.preventDefault();
            }

            if (!this.error) {
                sendAnalytics(
                    event,
                    this.analytics,
                    this.productId,
                    this.currentPrice
                );
            }
        },
        setPrice(price) {
            this.currentPrice = price;
            this.$refs.customPrice.value = '';
            this.$refs.customPrice.maskRef.value = '';
            this.$refs.customPrice.maskRef.updateValue();
            this.useCustomPrice = false;
            this.customPriceFocus = false;
        },
        setCustomPrice(event) {
            this.currentPrice = parseFloat(
                event.target.value.replace(',', '.')
            );
            this.useCustomPrice = !!this.currentPrice;
        },
        getButtonText() {
            if (this.preselectGift) {
                return 'Anna Lahjaksi';
            }
            if (this.isRecurring) {
                return 'Liity Kummiksi';
            }
            return 'Lahjoita';
        },
        setCustomPriceFocus(value) {
            if (value === true) {
                this.customPriceFocus = true;
            }
            if (value === false && !this.useCustomPrice) {
                this.customPriceFocus = false;
            }
        },
    },
};
</script>
